import {Routes} from '@angular/router';
import {LicensesCertificationsPageComponent} from './licenses-certifications-page.component';
import {BoardSelectionScreenComponent} from './steps/board/selection/board-selection-screen.component';
import {AbmsBoardScreenComponent} from './steps/board/abms/abms-board-screen.component';
import {AbpsBoardScreenComponent} from './steps/board/abps/abps-board-screen.component';
import {AbmsBoardSubspecialtyScreenComponent} from './steps/board/abms-subspecialty/abms-board-subspecialty-screen.component';
import {SpecialtyExaminationScreenComponent} from './steps/board/specialty-examination/specialty-examination-screen.component';
import {BoardScreens, BoardScreensManager} from './steps/board/board-screens-manager.service';
import {AbmsBoardScreensManager} from './steps/board/abms/abms-board-screens-manager.service';
import {AbmsBoardSubspecialtyScreensManager} from './steps/board/abms-subspecialty/abms-board-subspecialty-screens-manager.service';
import {AbpsBoardScreensManager} from './steps/board/abps/abps-board-screens-manager.service';
import {
    ProfessionalStepScreens,
    ProfessionalStepScreensManager
} from './steps/professional/professional-step-screens-manager.service';
import {ProfessionalLicenseScreensManager} from './steps/professional/professional-license/professional-license-screens-manager.service';
import {PermitScreensManager} from './steps/professional/permit/permit-screens-manager.service';
import {ProfessionalLicenseScreenComponent} from './steps/professional/professional-license/professional-license-screen.component';
import {PermitScreenComponent} from './steps/professional/permit/permit-screen.component';
import {InactiveLicensesInformationScreenComponent} from './steps/inactive/inactive-licenses-information-screen.component';
import {DeaRegistrationScreensManager} from './steps/dea/dea-registration/dea-registration-screens-manager.service';
import {DeaRegistrationScreenComponent} from './steps/dea/dea-registration/dea-registration-screen.component';
import {DeaScreens, DeaScreensManager} from './steps/dea/dea-screens-manager.service';
import {DeaRegistrationInformationScreenComponent} from './steps/dea/dea-registration-information/dea-registration-information-screen.component';
import {LifeCertificationScreenComponent} from './steps/lifecertification/life-certification-screen.component';
import {LicensingExaminationScreenComponent} from './steps/licensingexamination/licensing-examination-screen.component';
import {ContinuingMedicalEducationScreenComponent} from './steps/cme/continuing-medical-education-screen.component';
import {AoaBoardScreenComponent} from './steps/board/aoa/aoa-board-screen.component';
import {AoaBoardScreensManager} from './steps/board/aoa/aoa-board-screens-manager.service';
import {AoaBoardSubspecialtyScreenComponent} from './steps/board/aoa-subspecialty/aoa-board-subspecialty-screen.component';
import {AoaBoardSubspecialtyScreensManager} from './steps/board/aoa-subspecialty/aoa-board-subspecialty-screens-manager.service';

/**
 * Created by Rodrigo Quesada on 24/11/16.
 */
const routes: Routes = [{
    path: 'licensesAndCertifications',
    component: LicensesCertificationsPageComponent,
    children: [
        {path: '', redirectTo: 'board', pathMatch: 'full'},
        {
            path: 'board',
            children: [
                {path: '', redirectTo: 'selection', pathMatch: 'full'},
                {
                    path: 'selection',
                    component: BoardSelectionScreenComponent,
                    data: {screen: {id: BoardScreens.SELECTION}}
                },
                {path: 'abms', redirectTo: 'abms/1', pathMatch: 'full'},
                {
                    path: 'abms/:index',
                    component: AbmsBoardScreenComponent,
                    data: {screen: {id: BoardScreens.ABMS, screensManager: AbmsBoardScreensManager}}
                },
                {path: 'abms/:abmsIndex/sub', redirectTo: 'abms/:abmsIndex/sub/1', pathMatch: 'full'},
                {
                    path: 'abms/:abmsIndex/sub/:index',
                    component: AbmsBoardSubspecialtyScreenComponent,
                    data: {
                        screen: {
                            id: BoardScreens.ABMS_SUBSPECIALTY,
                            screensManager: AbmsBoardSubspecialtyScreensManager
                        }
                    }
                },
                {path: 'abps', redirectTo: 'abps/1', pathMatch: 'full'},
                {
                    path: 'abps/:index',
                    component: AbpsBoardScreenComponent,
                    data: {screen: {id: BoardScreens.ABPS, screensManager: AbpsBoardScreensManager}}
                },
                {path: 'aoa', redirectTo: 'aoa/1', pathMatch: 'full'},
                {
                    path: 'aoa/:index',
                    component: AoaBoardScreenComponent,
                    data: {screen: {id: BoardScreens.AOA, screensManager: AoaBoardScreensManager}}
                },
                {path: 'aoa/:aoaIndex/sub', redirectTo: 'aoa/:aoaIndex/sub/1', pathMatch: 'full'},
                {
                    path: 'aoa/:aoaIndex/sub/:index',
                    component: AoaBoardSubspecialtyScreenComponent,
                    data: {
                        screen: {
                            id: BoardScreens.AOA_SUBSPECIALTY,
                            screensManager: AoaBoardSubspecialtyScreensManager
                        }
                    }
                },
                {
                    path: 'specialtyExamination',
                    component: SpecialtyExaminationScreenComponent,
                    data: {screen: {id: BoardScreens.SPECIALTY_EXAMINATION}}
                }
            ],
            data: {step: {screensManager: BoardScreensManager}}
        },
        {
            path: 'professionalLicense',
            children: [
                {path: '', redirectTo: '1', pathMatch: 'full'},
                {
                    path: ':index',
                    component: ProfessionalLicenseScreenComponent,
                    data: {
                        screen: {
                            id: ProfessionalStepScreens.PROFESSIONAL_LICENSE,
                            screensManager: ProfessionalLicenseScreensManager
                        }
                    }
                },
                {
                    path: ':professionalLicenseIndex/permit',
                    component: PermitScreenComponent,
                    data: {
                        screen: {id: ProfessionalStepScreens.PERMIT, screensManager: PermitScreensManager}
                    }
                }
            ],
            data: {step: {screensManager: ProfessionalStepScreensManager}}
        },
        {path: 'inactive', component: InactiveLicensesInformationScreenComponent},
        {
            path: 'dea',
            children: [
                {path: '', redirectTo: 'entry/1', pathMatch: 'full'},
                {
                    path: 'entry/:index',
                    component: DeaRegistrationScreenComponent,
                    data: {
                        screen: {id: DeaScreens.REGISTRATION, screensManager: DeaRegistrationScreensManager}
                    }
                },
                {
                    path: 'info',
                    component: DeaRegistrationInformationScreenComponent,
                    data: {
                        screen: {id: DeaScreens.INFO}
                    }
                }
            ],
            data: {step: {screensManager: DeaScreensManager}}
        },
        {path: 'lifeCertifications/:index', redirectTo: 'lifeCertifications', pathMatch: 'full'},
        {path: 'lifeCertifications', component: LifeCertificationScreenComponent},
        {path: 'licensingExaminations/:index', redirectTo: 'licensingExaminations', pathMatch: 'full'},
        {path: 'licensingExaminations', component: LicensingExaminationScreenComponent},
        {path: 'continuingMedicalEducations/:index', redirectTo: 'continuingMedicalEducations', pathMatch: 'full'},
        {path: 'continuingMedicalEducations', component: ContinuingMedicalEducationScreenComponent}
    ],
    data: {section: {title: 'Licenses & Certifications'}, impersonationAllowed: true}
}];
export default routes;

export const screenManagers = [
    BoardScreensManager, AbmsBoardScreensManager, AbmsBoardSubspecialtyScreensManager, AbpsBoardScreensManager, AoaBoardScreensManager, AoaBoardSubspecialtyScreensManager,
    ProfessionalStepScreensManager, ProfessionalLicenseScreensManager, PermitScreensManager,
    DeaScreensManager, DeaRegistrationScreensManager
];



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/pages/licenses-certifications/licenses-certifications-page.routing.ts